import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { BookOutlined, UserOutlined, FileTextOutlined, DollarOutlined, DashboardOutlined } from '@ant-design/icons';
import { getUserInfo } from '../../utils/auth';
import { UserRole } from '../../constants/user';
import './styles.css';

const MobileBottomNav: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const userInfo = getUserInfo();
  const isAdmin = userInfo?.role === UserRole.ADMIN;
  const isFinance = userInfo?.role === UserRole.FINANCE;
  const isLawyer = userInfo?.role === UserRole.LAWYER;

  const getNavItems = () => {
    if (isFinance) {
      return [
        { key: '/finance', icon: <DollarOutlined />, label: '财务' },
      ];
    }

    if (isLawyer) {
      return [
        { key: '/workspace', icon: <BookOutlined />, label: '工作台' },
        { key: '/cases', icon: <FileTextOutlined />, label: '案件' },
      ];
    }

    const items = [
      { key: '/workspace', icon: <BookOutlined />, label: '工作台' },
      { key: '/leads', icon: <UserOutlined />, label: '线索' },
      { key: '/cases', icon: <FileTextOutlined />, label: '案件' },
    ];

    if (isAdmin) {
      items.push(
        { key: '/finance', icon: <DollarOutlined />, label: '财务' },
        { key: '/dashboard', icon: <DashboardOutlined />, label: '数据' }
      );
    }

    return items;
  };

  const navItems = getNavItems();

  const isActive = (key: string) => {
    return location.pathname.startsWith(key);
  };

  return (
    <div className="mobile-bottom-nav">
      {navItems.map(item => (
        <div
          key={item.key}
          className={`nav-item ${isActive(item.key) ? 'active' : ''}`}
          onClick={() => navigate(item.key)}
        >
          <div className="nav-icon">{item.icon}</div>
          <div className="nav-label">{item.label}</div>
        </div>
      ))}
    </div>
  );
};

export default MobileBottomNav;
